module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_c('vbl-input', {
    attrs: {
      "placeholder": "提示"
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  })], 1), _c('br'), _vm._v("\n    禁用     \n    "), _c('p', [_c('vbl-input', {
    attrs: {
      "placeholder": "提示",
      "disabled": ""
    },
    model: {
      value: (_vm.val2),
      callback: function($$v) {
        _vm.val2 = $$v
      },
      expression: "val2"
    }
  })], 1), _c('br'), _vm._v("\n    带关闭   \n    "), _c('p', [_c('vbl-input', {
    attrs: {
      "placeholder": "提示",
      "clear": ""
    },
    model: {
      value: (_vm.val2),
      callback: function($$v) {
        _vm.val2 = $$v
      },
      expression: "val2"
    }
  })], 1), _c('br'), _vm._v("\n    带icon   \n    "), _c('p', [_c('vbl-input', {
    attrs: {
      "placeholder": "提示",
      "icon": "ion-ios-arrow-forward"
    },
    model: {
      value: (_vm.val2),
      callback: function($$v) {
        _vm.val2 = $$v
      },
      expression: "val2"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57e05805","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblInput/example/vblInputExample.vue
// module id = 268
// module chunks = 0